/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Diversity and Career',
    SITE_DESCRIPTION:
      'Job seeker: stop your job search. Get matched with thousands of quality jobs. Employers: stop paying for job posting. Post jobs for free and pay only to contact qualified candidates that meet your requirements',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/diversityandcareer/logo.png',
      faviconsPath: '/static/diversityandcareer',
      loginImage: '/static/diversityandcareer/diversityandcareer_login.jpg',
    },
    OG_IMAGE: '/static/diversityandcareer/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#00AFE0',
        secondary: '#121212',
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-4MF6HF1ZX9', 'G-04SBN34ERZ'],
    BLOG_FEATURE_ACTIVE: true,
  },
});
